import React from "react";

import { css } from "@emotion/core";
import { Currency } from "@zapier/currency";
import { CurrencyDropdown } from "@zapier/checkout/esm/components";
import { Spacer, Field, Text, useTheme } from "@zapier/design-system";
import { useApolloInjection } from "@zapier/checkout/esm/contexts/ApolloInjection";

const containerStyles = css`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;

  @media (max-width: 375px) {
    display: block;
    }
  }
`;

type Props = {
  onSelectCurrency: (currency: Currency) => void;
  selectedCurrency: Currency;
};

export const ChangePlanCurrencyDropdown = ({
  onSelectCurrency,
  selectedCurrency,
}: Props) => {
  const { isRebrand } = useTheme();
  const { useQuery } = useApolloInjection();

  if (isRebrand) {
    return (
      <div css={containerStyles}>
        <Field
          label="Payment currency"
          renderInput={() => (
            <CurrencyDropdown
              onSelectCurrency={onSelectCurrency}
              selectedCurrency={selectedCurrency}
              useQuery={useQuery}
            />
          )}
        />
      </div>
    );
  }

  return (
    <div css={containerStyles}>
      <Text tag="span" type="paragraph3Bold">
        Pay with:
      </Text>
      <Spacer width={10} />
      <CurrencyDropdown
        onSelectCurrency={onSelectCurrency}
        selectedCurrency={selectedCurrency}
        useQuery={useQuery}
      />
    </div>
  );
};
